import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getListeStructures() {
    const response = await axios.get("/api/gestion/structures");
    return response.data;
  },
  async getListeStructuresCsv() {
    const response = await axios.get("/api/gestion/csv/structures");
    return response.data;
  },
  async getStructure(id) {
    const response = await axios.get("/api/admin/structures/" + id);
    return response.data;
  },
  async deleteStructure(id) {
    const response = await axios.delete("/api/admin/structures/" + id);
    return response.data;
  },
  async addStructure(structure) {
    const response = await axios.post("/api/admin/structures", structure);
    return response.data;
  },
  async updateStructure(id, structure) {
    const response = await axios.put("/api/admin/structures/" + id, structure);
    return response.data;
  },
};
